<div class="main-container">
  @if (!isSuccessStep) {
    <header>
      <img src="assets/img/addenda-icon.png"
           alt="addenda">
      <div class="header-content">
        <strong>{{ 'free_trial_signup_title' | translate }}</strong>
        <span>{{ 'self_registration_msg' | translate }}</span>
      </div>
    </header>

    <div class="border">
      <div class="highlight"></div>
    </div>

    <div class="signup-flow-meta">
      <button type="button"
              class="flow-back"
              [attr.aria-label]="'back' | translate"
              (click)="goBack()">
        <mat-icon svgIcon="arrow-back-left"></mat-icon>
        <span>{{ 'back' | translate }}</span>
      </button>
    </div>

    @switch (currentStep) {
      @case ('form') {
        <div class="main-content">
          @if (!hideNotification) {
            <div class="notification">
              <mat-icon svgIcon="lock"></mat-icon>
              <span>{{ 'privacy_issue_msg' | translate }}</span>
              <mat-icon svgIcon="cross"
                        class="right-icon"
                        (click)="hideNotification = true"></mat-icon>
            </div>
          }

          <main>
            <form [formGroup]="signupForm"
                  novalidate>
              <section>
                <div class="form-row">
                  <div class="xa-form-group">
                    <xa-text formControlName="businessName"
                             [required]="true"
                             [blockMaxLength]="true"
                             [maxLength]="200"
                             label="{{ 'business_name' | translate }}">
                    </xa-text>
                    @if (getFieldError('businessName')) {
                      <p class="field-error">{{ getFieldError('businessName') }}</p>
                    }
                  </div>
                  <div class="xa-form-group mobile-group">
                    <div class="mobile-fields">
                      <div class="form-label uppercase">{{ 'enter_mobile_number' | translate }} <span
                              class="required">*</span></div>
                      <div class="control-wrapper">
                        <xa-select class="code"
                                   [config]="codeConfig"
                                   [options]="countryList"
                                   formControlName="mobileCountryCode">
                        </xa-select>
                        <xa-tel formControlName="mobileNumber"
                                placeholder="{{ 'mobile_number' | translate }}">
                        </xa-tel>
                      </div>
                    </div>
                    @if (getFieldError('mobileCountryCode') || getFieldError('mobileNumber')) {
                      <p class="field-error">
                        {{ getFieldError('mobileCountryCode') || getFieldError('mobileNumber') }}
                      </p>
                    }
                  </div>
                </div>

                <div class="form-row">
                  <div class="xa-form-group">
                    <xa-text formControlName="email"
                             [required]="true"
                             [blockMaxLength]="true"
                             [maxLength]="254"
                             label="{{ 'email_id' | translate }}">
                    </xa-text>
                    @if (getFieldError('email')) {
                      <p class="field-error">{{ getFieldError('email') }}</p>
                    }
                  </div>
                  <div class="xa-form-group">
                    <xa-select [config]="countryConfig"
                               [options]="countryList"
                               formControlName="country">
                    </xa-select>
                    @if (getFieldError('country')) {
                      <p class="field-error">{{ getFieldError('country') }}</p>
                    }
                  </div>
                </div>
              </section>

              <section>
                @if (!disableRecaptchaForSelfSignup) {
                  <div class="recaptcha-container">
                    <re-captcha formControlName="recaptchaKey"></re-captcha>
                    @if (getFieldError('recaptchaKey')) {
                      <p class="field-error">{{ getFieldError('recaptchaKey') }}</p>
                    }
                  </div>
                }

                <input type="hidden"
                       formControlName="planType">
              </section>
            </form>
          </main>

          <footer>
            <xa-button (click)="submitSignup()"
                       type="radius"
                       [disabled]="disableFormSubmit">{{ 'submit' | translate }}</xa-button>
          </footer>
        </div>
      }
      @case ('emailOtp') {
        <section class="otp-card">
          <div class="otp-content">
            <h2>{{ 'enter_otp_code' | translate }}</h2>
            <p>{{ 'free_trial_otp_msg_email' | translate }}</p>

            <div class="contact-block">
              <div class="section-label">{{ 'your_email' | translate }}</div>
              <span>{{ emailAddress }}</span>
            </div>

            <div class="otp-block">
              <div class="section-label">{{ 'enter_otp' | translate }}</div>
              <ng-otp-input [config]="otpConfig"
                            (onInputChange)="onEmailOtpChange($any($event))"></ng-otp-input>
              @if (emailOtpStatus === 'error') {
                <div class="otp-feedback error">{{ emailOtpError }}</div>
              }
              @if (emailOtpStatus === 'success') {
                <div class="otp-feedback success">{{ 'success' | translate }}</div>
              }
            </div>
          </div>

          <footer class="otp-actions">
            <xa-button type="radius"
                       [disabled]="disableEmailOtpSubmit"
                       (click)="verifyEmailOtpStep()">{{ 'submit' | translate }}</xa-button>
          </footer>
        </section>
      }
      @case ('mobileOtp') {
        <section class="otp-card">
          <div class="otp-content">
            <h2>{{ 'enter_otp_code' | translate }}</h2>
            <p>{{ 'free_trial_otp_msg_mobile' | translate }}</p>

            <div class="contact-block">
              <div class="section-label">{{ 'your_mobile' | translate }}</div>
              <span>{{ mobileNumber }}</span>
            </div>

            <div class="otp-block">
              <div class="section-label">{{ 'enter_otp' | translate }}</div>
              <ng-otp-input [config]="otpConfig"
                            (onInputChange)="onMobileOtpChange($any($event))"></ng-otp-input>
              @if (mobileOtpStatus === 'error') {
                <div class="otp-feedback error">{{ mobileOtpError }}</div>
              }
              @if (mobileOtpStatus === 'success') {
                <div class="otp-feedback success">{{ 'success' | translate }}</div>
              }
            </div>
          </div>

          <footer class="otp-actions">
            <xa-button type="radius"
                       [disabled]="disableMobileOtpSubmit"
                       (click)="verifyMobileOtpStep()">{{ 'submit' | translate }}</xa-button>
          </footer>
        </section>
      }
    }
  } @else {
    <div class="submit-flow">
      <div class="submit-card">
        <mat-icon svgIcon="submit-success"></mat-icon>
        <div class="content">
          <strong>{{ 'free_trial_signup_success_title' | translate }}</strong>
          <p class="message-text">{{ 'free_trial_signup_success_message' | translate }}</p>
        </div>
      </div>
    </div>
  }
</div>
